import TableDataSavePage from './TableDataSavePage';
export default TableDataSavePage;
